import { render } from "./Foot.vue?vue&type=template&id=fd0a1036&scoped=true"
import script from "./Foot.vue?vue&type=script&lang=js"
export * from "./Foot.vue?vue&type=script&lang=js"

import "./Foot.vue?vue&type=style&index=0&id=fd0a1036&scoped=true&lang=css"

import exportComponent from "E:\\软件项目\\深圳官网\\official-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd0a1036"]])

export default __exports__